import { Helmet } from "react-helmet";
import Footer from "../components/footer";
import Header from "../components/header";
import TopNavabr from "../components/topNavabr";

import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import Spinner from "../components/spinner";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";
import careerImage from "../images/build-your-career.jpg";
import isoImage from "../images/iso.png";

function getBgColor(status) {
  console.log(status);
  let btnColor = "bg-success";

  if (status.toLowerCase() === "closed") {
    btnColor = "bg-danger";
  } else if (status.toLowerCase() === "apply now") {
    btnColor = "bg-success";
  } else if (status.toLowerCase() === "full seat") {
    btnColor = "bg-american-yellow";
  } else if (status.toLowerCase() === "coming soon") {
    btnColor = "bg-primary";
  }

  return btnColor;
}

export default function BuildYourCareer() {
  const { data, isLoading, isError } = useQuery(
    ["build-your-career"],
    async () => {
      const response = await window.fetch(`${BASE_URL}/intern-all-job`);
      return await response.json();
    }
  );

  // const navigate = useNavigate();

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    throw new Error("Unable to load data");
  }
  return (
    <>
      <Helmet>
        <title>AFRO || Career</title>
      </Helmet>
      <TopNavabr />
      <Header bannerBackground="image" staticImageURL={careerImage}>
        <div className="pt-7 pb-5 container">
          <div className="row header-background-image-size">
            <h1 className="fs-60 text-capitalize flex align-items-center col-12 col-md-6 gilroy-bold">
              Build Your Career
            </h1>
            <p className="fs-22 gilroy-bold">From Learning to Earning</p>
            <div className="pt-5">
              <Link
                // href="https://www.linkedin.com/company/afrosocial247/"
                // target="_blank"
                // rel="noreferrer"
                to="/career"
                className="text-uppercase fs-16 header-button text-orange-ryb fw-900 text-decoration-none d-inline-block text-center"
              >
                Apply for Opportunities
              </Link>
            </div>
          </div>
        </div>
      </Header>
      <section className="container-fluid px-0" id="cv">
        <div style={{ backgroundColor: "#f4f4f4" }}>
          <div className="container pt-7 pb-7">
            <div className="row">
              <div className="col-12 col-lg-5 text-center">
                <img src={isoImage} className="img-fluid" alt="" />
              </div>
              <div className="col-12 col-lg-7 text-center my-auto">
                <h2 className="fs-56 gilroy-bold mt-5 mt-lg-0">
                  Evaluate Your Training
                </h2>{" "}
                <p className="fs-18 py-5">
                  Provide feedback on your training program in order to improve
                  your learning experience. We will also use your review to
                  asses your progress and development.
                </p>
                <div className="">
                  <a
                    href="https://dars.afro-academy.com"
                    target="_blank"
                    rel="noreferrer"
                    className={`text-decoration-none px-5 d-inline-block py-3 fs-14 mb-5 text-uppercase build-your-project-btn`}
                  >
                    Teacher
                  </a>
                  <a
                    href="https://dars.afro-academy.com"
                    target="_blank"
                    rel="noreferrer"
                    className={` ms-5 text-decoration-none px-5 d-inline-block py-3 fs-14 mb-5 text-uppercase build-your-project-btn`}
                  >
                    Student
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container-fluid mt-5">
          <div className="ms-13 me-13">
            <div className="container mt-3 mb-5">
              <div className="row">
                {data?.datas?.map((slider, index) => (
                  <div
                    key={index}
                    className="col-12 col-md-6 col-lg-4 h-full my-4"
                  >
                    <div
                      className="review-shadow bg-white rounded-lg cursor-pointer transform-up  position-relative pb-4 h-full"
                      style={{ height: "100%" }}
                      // onClick={() => {
                      //   navigate(`/service/${slider?.id}`);
                      // }}
                    >
                      <div>
                        <img
                          src={`${IMAGE_BASE_URL}/${slider?.image}`}
                          // src="https://test.afro-group.net/public/uploads/index/afro1668120324.jpg"
                          alt={slider?.name}
                          style={{
                            borderRadius: "10px 10px 0 0",
                            // width: "100%",
                            // height: "35rem",
                          }}
                          className="img-fluid"
                        />
                        <div className="p-3">
                          <span>{}</span>
                          <h3 className="fs-24  mb-3 mt-4 text-capitalize text-charleston-green gilroy-bold text-american-yellow text-center">
                            {slider?.title}
                            {/* Internship Summer Program */}
                          </h3>
                          <h3 className="fs-20 my-3 text-capitalize text-charleston-green text-center">
                            {slider?.heading}
                            {/* Internships are usually short term (1-3 months) */}
                          </h3>
                          <div className="d-flex justify-content-center mt-4">
                            {slider?.apply_status?.toLowerCase() ===
                            "apply now" ? (
                              <Link
                                to="/career"
                                className={`text-decoration-none bg-american-yellow px-5 d-inline-block py-3 fs-14 text-white mb-5 text-uppercase border-0 ${getBgColor(
                                  slider?.apply_status
                                )}`}
                              >
                                {slider?.apply_status}
                              </Link>
                            ) : (
                              <button
                                className={`text-decoration-none bg-american-yellow px-5 d-inline-block py-3 fs-14 text-white mb-5 text-uppercase border-0 ${getBgColor(
                                  slider?.apply_status
                                )}`}
                              >
                                {slider?.apply_status}
                              </button>
                            )}
                          </div>
                          <div className="review-card-border"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: "#212529" }}>
          <div className="ms-47 me-47 pt-7 pb-7">
            <div className="text-center text-white">
              <h2 className="fs-22 gilroy-bold">Build your future with AFRO</h2>
              <p className="fs-18">
                Whether it's business or engineering & technology, we're here to
                help get you to your future.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
